import axios from "axios";
import { Config } from "../Config";
import { clearLocalStorageExcept, userAccessToken } from "../helpers";

const baseURL = Config.apiServerUrl;

// ---- SAME-FILE NAV BRIDGE (no hooks here) ----
let _navigate = null;           // will be set from a Router-aware component
let _isRedirecting = false;     // debounce multiple 401 redirects

export const bindApiNavigate = (navigateFn) => {
  _navigate = typeof navigateFn === "function" ? navigateFn : null;
};

const appNavigate = (to, options) => {
  if (_navigate) {
    _navigate(to, options); // ✅ SPA navigation (no reload)
  } else {
    console.warn("API navigate not bound yet; skip redirect:", to);
  }
};
// ----------------------------------------------

const API = axios.create({ baseURL });

API.interceptors.request.use(
  (config) => {
    const token = userAccessToken();

    // 🚫 If no token, stop immediately (no request sent)
    if (!token) {
      return Promise.reject(null); // caller can detect skipped request
    }

    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      if (_isRedirecting) return Promise.reject(error); // debounce
      _isRedirecting = true;

      await clearLocalStorageExcept();

      if (!window.location.pathname.includes("/login")) {
        appNavigate("/login", { replace: true }); // ← SPA redirect
      }

      // Release debounce after short delay
      setTimeout(() => { _isRedirecting = false; }, 300);
    }
    return Promise.reject(error);
  }
);

export default API;
